'use client';
import { scaledRemCalc } from '@mnd-frontend/utils';
import { memo } from 'react';
import styled from 'styled-components';
import { withComponentsContext } from '../../context';
import LegendItem from './LegendItem';

const LegendWrapper = styled.div`
  flex-shrink: 0;
  height: 100%;
  min-width: ${scaledRemCalc(160)};
  max-width: 100%;
  position: relative;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 100%;
  margin-left: ${scaledRemCalc(-24)};
  margin-top: ${scaledRemCalc(-8)};
  & > * {
    margin-left: ${scaledRemCalc(24)};
    margin-top: ${scaledRemCalc(8)};
  }
`;

const Legend = ({ items }: any) => {
  return (
    <LegendWrapper>
      <ItemWrapper>
        {items.map((item: any) => (
          <LegendItem key={item.id} {...item} />
        ))}
      </ItemWrapper>
    </LegendWrapper>
  );
};

export default memo(withComponentsContext(Legend, 'Legend'));
